import NiceModal from "@ebay/nice-modal-react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import './App.scss';
import { Routes } from "./Routes";
import { useTheme } from './redux/hooks/UseTheme';

function App() {
  useTheme(); // This will handle the body class
  return (
    <NiceModal.Provider>
      <RouterProvider router={createBrowserRouter(Routes)} />
    </NiceModal.Provider>
  );
}
export default App;
